import {
  fetchWrapper,
  handleResponse,
  formatBody,
  hcUrl,
  buildOpts,
} from 'services/RequestService/helpers';

const addMealAddonSelection = async ({ params: { mealAddonId, quantity } }) => {
  const response = await fetchWrapper(
    hcUrl('/meal_addon_selections'),
    buildOpts({
      method: 'POST',
      body: formatBody({
        mealAddonSelection: {
          mealAddonId,
          quantity,
        },
      }),
    })
  );
  return handleResponse(response);
};

const updateMealAddonSelections = async ({ params }) => {
  const response = await fetchWrapper(
    hcUrl('/meal_addon_selections/batch_update'),
    buildOpts({
      method: 'PATCH',
      body: formatBody({
        mealAddonSelections: Object.hasOwn(params, 'mealAddons')
          ? { mealAddons: params.mealAddons }
          : { mealAddonIds: params.mealAddonIds },
      }),
    })
  );
  return handleResponse(response);
};

export { addMealAddonSelection, updateMealAddonSelections };
